import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="code-editor">
        <div className="editor-header">
          <span className="dot red"></span>
          <span className="dot yellow"></span>
          <span className="dot green"></span>
          <span className="editor-title">About.jsx</span>
        </div>

        <div className="code-body">
          <div className="line-numbers">
            {[...Array(10)].map((_, i) => (
              <span key={i}>{i + 1}</span>
            ))}
          </div>

          <div className="code-content">
            <p>
              <span className="keyword">const</span> <span className="var">About</span> = () =&gt; {'{'}
            </p>
            <p className="indent">
              <span className="keyword">return</span> (
            </p>
            <p className="indent-2">
              &lt;<span className="tag">section</span> id=
              <span className="string">"about"</span>&gt;
            </p>
            <p className="indent-3 typing-effect">
              Hi, I'm <span className="var">Jathin</span>, a full-stack developer skilled in{' '}
              <span className="tech">.NET</span> and <span className="tech">MERN</span> stacks.
            </p>
            <p className="indent-2">
              &lt;/<span className="tag">section</span>&gt;
            </p>
            <p className="indent">);</p>
            <p>{'}'}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
